export default "__VITE_ASSET__C8Rvy0iK__"